import Rest from '../../Rest'

export default class SystematicIntimidationFormService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/systematic_intimidation_form'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  getListLegalEntity(paramEncrypt: String) {
    return this.get(`legal_entity/${paramEncrypt}`).then(data => {
      return data
    })
  }

}
